import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "./theme";
import { AuthProvider } from "./context/AuthContext";
import { TrialStatusProvider } from "./context/TrialStatusContext";
import { BusinessUnitProvider } from "./context/BusinessUnitContext";
import { NotificationsProvider } from "./context/NotificationsContext";
import "./i18n";


if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then(regs => Promise.all(regs.map(r => r.unregister())))
    .then(() => {
      if (!sessionStorage.getItem('sw-cleaned')) {
        sessionStorage.setItem('sw-cleaned', '1');
        window.location.reload();
      }
    })
    .catch(() => {});
}

// Suppress Chrome's noisy ResizeObserver dev error overlay in development
if (process.env.NODE_ENV === "development") {
  const ignoreResizeObserverError = (event) => {
    const message = event?.message || event?.reason?.message || "";
    if (
      typeof message === "string" &&
      (message.includes("ResizeObserver loop limit exceeded") ||
        message.includes("ResizeObserver loop completed with undelivered notifications"))
    ) {
      event.stopImmediatePropagation?.();
      event.preventDefault?.();
    }
  };
  window.addEventListener("error", ignoreResizeObserverError);
  window.addEventListener("unhandledrejection", ignoreResizeObserverError);

  // Also silence CRA overlay by filtering console.error for this specific warning
  const originalConsoleError = console.error;
  console.error = (...args) => {
    const first = args?.[0];
    const text = typeof first === "string" ? first : first?.message;
    if (
      typeof text === "string" &&
      (text.includes("ResizeObserver loop limit exceeded") ||
        text.includes("ResizeObserver loop completed with undelivered notifications"))
    ) {
      return;
    }
    originalConsoleError(...args);
  };
}

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <AuthProvider>
          <NotificationsProvider>
            <TrialStatusProvider>
              <BusinessUnitProvider>
                <App />
              </BusinessUnitProvider>
            </TrialStatusProvider>
          </NotificationsProvider>
        </AuthProvider>
      </BrowserRouter>
    </ChakraProvider>
  </React.StrictMode>
);

// If the page was pre-rendered, hydrate to attach event listeners to existing HTML.
// Otherwise, do a normal client render.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  const root = ReactDOM.createRoot(container);
  root.render(app);
}

reportWebVitals();
